<template>
  <div v-if="debugModeOn" class="debug-notifier">
    <v-snackbar v-model="debugNotification" color="success" transition="slide-y-reverse-transition" :timeout="4000">
      {{ debugNotification || "" }}
    </v-snackbar>
  </div>
</template>

<script setup>
import { storeToRefs } from "pinia";
import { useDebugStore } from "../../stores/debug";

const debugStore = useDebugStore();
const { debugModeOn, debugNotification } = storeToRefs(debugStore);
</script>
